<template>
  <div>
    <index-user-types />
    <create-user-types />
    <view-user-types />
  </div>
</template>

<script>
    import IndexUserTypes from '../../../components/setup/user_types/IndexUserType';
    import ViewUserTypes from '../../../components/setup/user_types/ViewUserType';
    import CreateUserTypes from '../../../components/setup/user_types/CreateUserType';

  export default {
    name: 'UserTypes',
    components:{
      'index-user-types': IndexUserTypes,
      'view-user-types': ViewUserTypes,
      'create-user-types': CreateUserTypes
    }
  };
</script>

<style scoped>

</style>